<template>
    <v-form ref="form" v-model="valid" data-cy="authorization-form" @keyup.native.enter="auth">
        <v-text-field
            v-model="email"
            :placeholder="$t('email')"
            type="email"
            :rules="validationRules('email', [emailRule, requiredRule])"
            required
            data-cy="authorization-email-input"
            :bg-color="dark ? 'white' : undefined"
            density="compact"
            variant="outlined"
        />
        <v-text-field
            v-model="password"
            :placeholder="$t('password')"
            type="password"
            :rules="[requiredRule('password')]"
            required
            data-cy="authorization-password-input"
            :bg-color="dark ? 'white' : undefined"
            density="compact"
            variant="outlined"
        />
        <div class="d-flex">
            <v-btn
                :loading="isLoading"
                :disabled="isLoading || !valid"
                color="primary"
                class="mr-2"
                :theme="dark ? 'dark' : 'light'"
                data-cy="authorization-submit-button"
                @click="auth"
            >
                {{ $t('sign_in') }}
            </v-btn>
            <v-btn
                variant="outlined"
                color="primary"
                style="text-transform: none"
                @click="$emit('switch-forgot-password')"
            >
                {{ $t('forgot_your_password') }}?
            </v-btn>
        </div>
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import {transferFavoritesFromStorage} from '@/utils/favorite'
    import {EventBus, LOAD_WISHLIST} from '@/utils/event-bus'

    @Component
    export class AuthorizationForm extends mixins(FormValidationRulesMixin) {
        @Prop({default: false, type: Boolean}) dark

        email = null
        password = null
        valid = false

        mounted() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (document.querySelectorAll('input:-webkit-autofill').length) {
                        this.valid = true
                    }
                }, 0)
            })
        }

        async auth() {
            if (!this.valid) return

            try {
                await authStore.auth({
                    login: this.email,
                    password: this.password,
                })

                await transferFavoritesFromStorage(authStore.person.personId)
                EventBus.$emit(LOAD_WISHLIST)
            } catch (e) {
                if (e.status === 401) {
                    this.$toast.error(this.$t('incorrect_credentials'))
                } else if (e.errors && e.errors.length) {
                    this.$toast.error(e.errors[0].message)
                }
            }
        }

        get isLoading() {
            return runtimeStore.authActive
        }
    }

    export default AuthorizationForm
</script>
